import { render, staticRenderFns } from "./Leader.vue?vue&type=template&id=4a70cb96&scoped=true&"
import script from "./Leader.vue?vue&type=script&lang=js&"
export * from "./Leader.vue?vue&type=script&lang=js&"
import style0 from "../../../../company/statistics/css/fullCompanyDetail.css?vue&type=style&index=0&id=4a70cb96&scoped=true&lang=css&"
import style1 from "../../../../company/statistics/css/commonCompany.css?vue&type=style&index=1&id=4a70cb96&scoped=true&lang=css&"
import style2 from "./Leader.vue?vue&type=style&index=2&id=4a70cb96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a70cb96",
  null
  
)

export default component.exports